import { Component,
         OnInit } from '@angular/core';

// import { SocialAuthService,
//          GoogleLoginProvider,
//          SocialUser } from '@abacritt/angularx-social-login';

// import { takeUntil } from 'rxjs/operators';

// // import { PageHelper } from 'src/app/_core/index'
// import { AppHelper,
//          AuthService,
//          CookieService,
//          PageHelper, 
//          User} from 'src/app/_core/index'

@Component({
  selector: 'ss-app-container',
  templateUrl: './app-container.component.html',
  styleUrls: ['./app-container.component.scss']
})
export class AppContainerComponent implements OnInit {


  constructor(
    // protected socialAuthService: SocialAuthService,
  ) { }


  ngOnInit(): void {
    // this.user$ = this.userStream()
  }

  // ngOnChanges() {

  // }

  // ngOnDestroy() {
  //   if (this.user$) this.user$.unsubscribe()
  // }
}
